import {AppSkAdNetworkStatus, MediationEngine, Platform} from '../../../../globalTypes';

export enum AppOrderField {
    Name = 'NAME',
    BundleId = 'BUNDLE_ID',
    IntegrationStatus = 'INTEGRATION_STATUS',
    LatestSdkVersion = 'LATEST_SDK_VERSION',
    // eslint-disable-next-line @typescript-eslint/no-shadow
    MediationEngine = 'MEDIATION_ENGINE',
}

export enum SyncStatus {
    SYNC_FORBIDDEN = 'SYNC_FORBIDDEN',
    SYNC_DISABLED = 'SYNC_DISABLED',
    ACCOUNT_IS_NOT_SELECTED = 'ACCOUNT_IS_NOT_SELECTED',
    SYNCED = 'SYNCED',
    RESYNC_NEEDED = 'RESYNC_NEEDED',
    SYNC_NEEDED = 'SYNC_NEEDED',
}

export enum SdkStatus {
    DEPRECATED = 'DEPRECATED',
    NO_SDK = 'NO_SDK',
    SUPPORTED = 'SUPPORTED',
    UP_TO_DATE = 'UP_TO_DATE',
}

export enum IntegrationStatus {
    NOT_INTEGRATED = 'NOT_INTEGRATED',
    FIRST_NETWORK_CONNECTED = 'FIRST_NETWORK_CONNECTED',
    SECOND_NETWORK_CONNECTED = 'SECOND_NETWORK_CONNECTED',
}

export enum AppPublishStatus {
    YES = 'YES',
    NO = 'NO',
}

export interface App {
    id: string;
    name: string;
    applicationKey: string;
    bundleId: string;
    platform: Platform;
    published: AppPublishStatus;
    integrationStatus: IntegrationStatus;
    skAdNetworkStatus: AppSkAdNetworkStatus;
    admobSyncStatus: {
        syncStatus: SyncStatus;
        account: {
            id: string;
            login: string;
        };
    };
    permissions: {
        canViewConfiguration: boolean;
        canViewAdNetworkMonitor: boolean;
        canViewLineItems: boolean;
    };
    iconUrl: string;
    mediationEngine: MediationEngine;
}

export interface AppList {
    nodes: App[];
    pageInfo: {
        currentPage: number;
        totalPages: number;
        pageSize: number;
    };
    totalCount: number;
    permissions: {
        canViewLinkedAccount: boolean;
    };
}

export interface AppOwner {
    id: string;
    email: string;
    permissions: {
        canViewNetworkAccount: boolean;
    };
}

export const AppPlatformIcons = {
    [Platform.IOS]: 'platform-app-store',
    [Platform.GOOGLE]: 'platform-google-play',
    [Platform.AMAZON]: 'platform-amazon',
};
